import { inject, Injectable } from '@angular/core';
import { Logger, LoggingService } from '../../logging/logging.service';
import { AppConfiguration, BasePageConfig, PageConfig } from '../../config/entities';
import { UserRoles } from '../../user/entities/user-roles';
import { ConfigService } from '../../config/services/config.service';
import { FeatureConfigs } from '../entities/curafida-frontend-configuration';
import { ConfigurationDetailFeatures } from '../../config/resources/configuration.resource';

@Injectable({
    providedIn: 'root',
})
export class MenuService {
    roles: UserRoles[] | string[] = [];
    configService = inject(ConfigService);
    protected readonly log: Logger;

    constructor(private loggingService: LoggingService) {
        this.log = this.loggingService.getLogger(this.constructor.name);
    }

    fetchSubPageConfig(subPagesConfig: BasePageConfig[], roles: UserRoles[] | string[]) {
        return subPagesConfig?.filter((page) => this.hasRoleAndModule(page, roles));
    }

    private hasRoleAndModule(page: PageConfig, roles: UserRoles[] | string[]) {
        const pageModule = page?.module as keyof ConfigurationDetailFeatures;
        if (this.configService.config()?.configuration?.features?.[pageModule]) {
            return this.configService.config()?.configuration?.features[pageModule].enabled;
        }
        if (!this.configService.frontendConfig().features?.[pageModule as keyof FeatureConfigs]?.enabled) {
            return false;
        }
        for (const pageRole of page.role) {
            return roles?.includes(pageRole as UserRoles);
        }
    }
}
